export const PUSH_LIVE_CONSTANTS = {
  LIVE_PAGE_TITLE: 'MLI Education | ',
  LIVE_PAGE_LABEL: 'MLI Education | Push-Live',
  ALL_ON_DEMAND_LIVES_LABEL: 'Push Live Activities',
  PUSH_LIVE_DETAILS_LABEL: 'Push Activity Details',
  ANSWER_RECORDED_MESSAGE: 'Your answer has been recorded. Please standby.',
  NOT_STARTED_TEXT: 'Please standby – There are no active questions at this time.',
  CLEARED_TEXT: 'Please standby – There are no active questions at this time.',
  ENDED_TEXT: 'The live activity has ended. Thank you for engaging in this learning experience.',
};

export const WORD_CLOUD_CONSTANTS = {
  QUESTION_TYPE: 'word-cloud',
  MAX_WORDS: 3,
  MAX_LENGTH: 255,
  INPUT_HINT: 'Up to 3 words',
  INVALID_MESSAGE: 'Please enter up to 3 words.',
  EMPTY_MESSAGE: 'No answers yet',
};

export const OPEN_RESPONSE_CONSTANTS = {
  QUESTION_TYPE: 'open-response',
  MAX_LENGTH: 400,
  INPUT_HINT: 'Type your answer here...',
  TOO_LONG_MESSAGE: 'Please keep your answer to 400 characters or fewer.',
  EMPTY_RESULT_MESSAGE: 'No responses selected yet',
};
